import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SpotifyFilledSvg from "@ant-design/icons-svg/es/asn/SpotifyFilled";
import AntdIcon from "../components/AntdIcon";
var SpotifyFilled = function SpotifyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SpotifyFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SpotifyFilled.displayName = 'SpotifyFilled';
}
export default /*#__PURE__*/React.forwardRef(SpotifyFilled);